import React from "react"
import { Asset, Link } from "../../../plugins/gatsby-plugin-atollon"
import parse from "html-react-parser"
import StructuredText from "../structured-text/custom-structured-text-renderer"
import { External, Download } from "../icons"

const Content = (props) => {
  return (
    <>
      <section className="venue-banner">
        <div className="venue-banner__inner">
          {props.bannerImage && <Asset asset={props.bannerImage} />}
        </div>
      </section>
      <section className="venue-main">
        <div className="venue-main__inner">
          <div className="venue-main__wrapper">
            <div className="venue-main__content">
              {props.title && <h2>{parse(props.title)}</h2>}
              {props.subtitle && <h3>{parse(props.subtitle)}</h3>}
              {props.richContent && <StructuredText data={props.richContent} />}
              {props.secondaryImage && <Asset asset={props.secondaryImage} />}

              <div className="venue-main__button">
                {props.buttons?.length > 0 && props.buttons[0].link?.length > 0 && props.buttons.map((btn, i) => (
                  <Link
                    key={i}
                    className={`btn ${i === 0 ? "btn--umber" : "btn--border"}`}
                    to={btn.link[0]?.externalLink ? btn.link[0]?.externalLink : btn.link[0]?.internalLink.permalink}
                    target='_blank' rel='noopener noreferrer'>
                    {btn.title}
                    {i === 1 && <External />}
                  </Link>
                ))}
              </div>
            </div>

            <div className="venue-main__image">
              {props.secondaryImage && <Asset asset={props.secondaryImage} />}
            </div>
          </div>
        </div>
      </section>
      <section className="venue-detail">
        <div className="venue-detail__inner">
          <div className="venue-detail__items">
            {
              props.location &&
              <div className="venue-detail__item">
                <h3>Location</h3>
                <StructuredText data={props.location} />
              </div>
            }
            {
              props.openingHours &&
              <div className="venue-detail__item">
                <h3>Opening Hours</h3>
                <StructuredText data={props.openingHours} />
              </div>
            }
          </div>

          {
            props.email && props.phone &&
            <div className="venue-detail__contact">
              <div className='venue-detail__info'>
                <h3>Contact</h3>
                {props.email && <Link to={`mailTo:${props.email}`} target='_blank' rel='noopener noreferrer'>{props.email}</Link>}
                {props.phone && <Link to={`tel:${props.phone}`} target='_blank' rel='noopener noreferrer'>{props.phone}</Link>}

                <div className="venue-detail__socials">
                  {props.socialLinks?.length > 0 && props.socialLinks[0].link?.length > 0 && props.socialLinks.map((btn, i) => (
                    <Link
                      key={i}
                      target='_blank' rel='noopener noreferrer'
                      to={btn.link[0]?.externalLink ? btn.link[0]?.externalLink : btn.link[0]?.internalLink.permalink}>
                      {btn.title}
                    </Link>
                  ))}
                </div>
              </div>
              <div className='venue-detail__button'>
                {props.virtualTourLink && <Link to={props.virtualTourLink} className="btn btn--border" target='_blank' rel='noopener noreferrer'>Virtual Tour</Link> }
                {props.viewMenuLink && <Link to={props.viewMenuLink} className="btn btn--border" target='_blank' rel='noopener noreferrer'>Venue Menu <Download /></Link> }
              </div>
            </div>
          }
        </div>
      </section>
    </>
  )
}

export default Content